import { config } from "@react-spring/core";
import { useEffect } from "react";
import { useSprings, animated } from "react-spring";

export default function SplitTitle({ title, willShow, visible, ...props }) {
  const [springs, api] = useSprings(title.length, (i) => ({
    config: config.gentle,
    y: visible ? 0 : willShow ? 100 : -110,
    delay: i * 100,
    opacity: visible ? 1 : 0,
    from: { y: willShow ? 100 : -110, opacity: 0 },
  }));

  useEffect(() => {
    api.start((i) => ({
      y: visible ? 0 : willShow ? 100 : -110,
      delay: i * 25,
      opacity: visible ? 1 : 0,
      //   from: { y: willShow ? 100 : -110 },
    }));
    return () => api.stop();
  }, [willShow, visible, api]);

  //   const springs = useTrail(title.length, {
  //     config: config.gentle,
  //     y: visible ? 0 : willShow ? 100 : -110,
  //     delay: willShow ? 2 : 0,
  //     from: { y: willShow ? 100 : -110 },
  //   });

  return (
    <h2
      className="text-4xl md:text-6xl xl:text-8xl text-white absolute left-0 bottom-0 h-full w-full font-normal tracking-tight"
      {...props}
    >
      {springs.map((styles, i) => (
        <animated.div
          className="inline-block whitespace-pre"
          style={styles}
          key={i}
        >
          {title[i]}
        </animated.div>
      ))}
    </h2>
  );
}
